<template>
  <div>
    <DesktopHeader
      :class="{ 'hide-mobile-slider': !getFilteredOffers.length }"
    ></DesktopHeader>
    <MobileHeader v-if="getFilteredOffers.length"></MobileHeader>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DesktopHeader from './Desktop_Header'
import MobileHeader from './Mobile_Header'
export default {
  name: 'BrandHeader',
  components: { DesktopHeader, MobileHeader },
  computed: {
    ...mapGetters(['getFilteredOffers']),
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .hide-mobile-slider {
    display: none;
  }
}
</style>
